"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.LeadAccessTokenTransport = exports.LeadAccessTokenCreateInput = void 0;
const typebox_1 = require("@sinclair/typebox");
exports.LeadAccessTokenCreateInput = typebox_1.Type.Object({
    leadID: typebox_1.Type.String({ format: 'uuid' }),
});
exports.LeadAccessTokenTransport = typebox_1.Type.Object({
    key: typebox_1.Type.String(),
    expires: typebox_1.Type.String(),
});
//# sourceMappingURL=lead-access-token-transport.js.map